import { IPolygon } from "../Models/Models";

export interface IReportMapAxios {
  GetBlockgroupPolygons(blockGroupIds: string[]): Promise<IPolygon[]>;
}
